import { useEffect, useRef } from "react";
import {
  RT,
  RT_META,
  connectRealtime,
  joinRoom,
  leaveRoom,
  makeCimInterdicoesRoom,
  on,
  off,
  onRealtimeMeta,
  offRealtimeMeta,
} from "../../../api/realtime";

export function useStatusCimRealtime({ onInvalidate }) {
  const timeoutRef = useRef(null);

  useEffect(() => {
    const room = makeCimInterdicoesRoom?.() || "cim:interdicoescim";
    let mounted = true;

    (async () => {
      try {
        await connectRealtime();
        if (!mounted) return;
        joinRoom(room);
      } catch {}
    })();

    const handleChange = (payload) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onInvalidate?.(payload), 60);
    };

    const handleReconnect = () => {
      onInvalidate?.({ reason: "reconnect" });
    };

    on(RT.CIM_INTERDICOES_CHANGED, handleChange);
    onRealtimeMeta(RT_META.RECONNECTED, handleReconnect);

    return () => {
      mounted = false;
      off(RT.CIM_INTERDICOES_CHANGED, handleChange);
      offRealtimeMeta(RT_META.RECONNECTED, handleReconnect);
      leaveRoom(room);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    };
  }, [onInvalidate]);
}
